import { NgModule } from '@angular/core';
import {
  CmsConfig,
  I18nConfig,
  provideConfig
} from '@spartacus/core';
import {
  orderTranslationChunksConfig,
  orderTranslationsDe,
  orderTranslationsEn
} from '@spartacus/order/assets';
import { ORDER_FEATURE, OrderRootModule } from '@spartacus/order/root';
import { nl as translationsNl } from '../../../../assets/i18n-assets/nl';

@NgModule({
  declarations: [],
  imports: [OrderRootModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [ORDER_FEATURE]: {
          module: () => import('@spartacus/order').then((m) => m.OrderModule),
        },
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: {
          en: orderTranslationsEn,
          de: orderTranslationsDe,
          nl: translationsNl,
        },
        chunks: orderTranslationChunksConfig,
        fallbackLang: 'en',
      },
    }),
  ],
})
export class OrderFeatureModule {}
